module.exports = __webpack_public_path__ + "img/Headportrait.388f8dbc.png";